import type { ShoppingItem } from '@/entities/shopping-item/schemas/shopping-item';
import { numberToInput } from '@/shared/components/form/number-to-input';
import { centsToInput } from '@/shared/lib/money/cents-to-input';
import type { ShoppingFormValues } from '../schemas/shopping-form-values';

export function toShoppingForm(entry?: ShoppingItem): ShoppingFormValues {
  return {
    name: entry?.name ?? '',
    category: entry?.category ?? 'other',
    quantity: numberToInput(entry?.quantity ?? 1),
    unit: entry?.unit ?? 'ud',
    estimate: centsToInput(entry?.estimated_price_cents),
    priority: entry?.priority ?? 'medium',
    needed_by: entry?.needed_by ?? '',
    store: entry?.store ?? '',
    url: entry?.url ?? '',
    notes: entry?.notes ?? '',
  };
}
